import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { ChipBase } from './styles/ChipBase';

const Chip = props => {
  const {
    textColor,
    backgroundColor,
    text,
    onClick,
    className,
  } = props;

  const handleClick = () => {
    onClick(text);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      onClick(text);
    }
  };

  return (
    <ChipBase
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      $color={backgroundColor}
      aria-label={text}
      tabIndex="0"
      className={className}
    >
      <Typography
        color={textColor}
        variant="text1"
        tag="span"
      >
        {text}
      </Typography>
    </ChipBase>
  );
};

Chip.defaultProps = {
  onClick: () => {},
  backgroundColor: 'white.dark',
  className: undefined,
  textColor: 'grayEmpress',
  text: '',
};

Chip.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
  textColor: PropTypes.string,
};

export default Chip;
